import ActionType from "../../Actions/ActionType";
import { TransportRoundTripType } from "../../Actions/ProjectSettings/TransportRoundTrip";

const initialState = {
    isTransportRoundTrip: false,
};

const TransportRoundTripReducer = (
  state = initialState,
  action: TransportRoundTripType
) => {
  switch (action.type) {
    case ActionType.TRANSPORT_ROUND_TRIP:
      return {
        ...state,
        isTransportRoundTrip: action.data,
      };
    default:
      return state;
  }
};

export default TransportRoundTripReducer;
